module.exports = __webpack_public_path__ + "images/watzoekje.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/decor_elementjes/watzoekje.png
// module id = 248
// module chunks = 0